import React,{useState} from 'react'
import Footer from '../inc/Footer'
import { FaLocationDot,FaEnvelope,FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import "../inc/GlobalVars";
function DeleteAccount() {
    const iconsStyles =
    {
        backgroundColor:"#fff",
        padding:"10px 12px",
        borderRadius:"50px",
        color:"#000",
        width:"10%"
    }
    const [formData, setFormData] = useState({
       
        mobile: "",
       
        message: "",
      });

      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
          const response = await axios.post(global.apiUrl +"/deleteAccount", formData);
            console.log("response"+response.status);
          if (response.status === 200) {
            // Show success toastr with the user's name
            toast.success(`Thank you!. We will contact you on ${formData.mobile}`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "colored",
            });
    
          } else {
            toast.error("Failed to submit your query. Please try again.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "colored",
            });
          }
        } catch (error) {
          console.error(error);
          toast.error("An error occurred. Please try again later.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        }
      };
  return (
    <div className=''>
        <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        />
        <div className='container contact-container mb-5 ps-5 pe-5 mt-5'>
            <div className='row d-flex justify-content-center position-relative'>
                <div className='col-md-5'>
                   <h2 className='text-white pt-5 '>Delete Account</h2>
                   <hr/>
                   <p className='ps-1 text-white'>If you wish to delete your account, please follow the steps below:</p>
                   <ul  style={{listStyleType:'Disc'}}>
                    <li className='ps-1 text-white' style={{listStyleType:'Disc'}}>Fill out the form with your account details.</li>
                    <li className='ps-1 text-white' style={{listStyleType:'Disc'}}>Our team will review your request and contact you for verification.</li>
                    <li className='ps-1 text-white' style={{listStyleType:'Disc'}}>Once verified, your account will be permanently deleted.</li>
                    <li className='ps-1 text-white' style={{listStyleType:'Disc'}}>This process may take a few days. Thank you for your patience!</li>
                    </ul>

                    <h2 className='text-white pt-3 '>Contact Details</h2>
                   <hr/>
                    <ul className='pt-2'>
                        <li className='mb-3'>
                            <div className='d-flex align-items-center'>
                                <span style={iconsStyles} className='d-flex align-items-center justify-content-center'>
                                    <FaEnvelope style={{fontSize:"22px"}} />
                                </span>
                                <span className='ps-1 text-white'>
                                    contact@indussparebazaar.in
                                </span>
                            </div>
                        </li>
                        <li className='mb-3'>
                            <div className='d-flex align-items-center'>
                                <span style={iconsStyles} className='d-flex align-items-center justify-content-center'>
                                    <FaPhoneAlt style={{fontSize:"22px"}} />
                                </span>
                                <span className='ps-1 text-white'>
                                +91 8222977001/003/004
                                </span>
                            </div>
                        </li>
                       
                    </ul>

                    
                </div>
                <div className='col-md-7'>
                    
                    <div className='contactBox ps-5 pe-5'>
                    <h4>Please Fill Up The Form</h4><hr/>
                    <form onSubmit={handleSubmit}>
      
      
      <div className="mb-2">
        <label>
          Registered Mobile Number <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="mobile"
          value={formData.mobile}
          onChange={handleInputChange}
          placeholder="Your Registered Mobile Number"
          required
        />
      </div>
      
      <div className="mb-3">
        <label>
          Reason <span className="text-danger">*</span>
        </label>
        <textarea
          className="form-control"
          name="message"
          rows="3"
          value={formData.message}
          onChange={handleInputChange}
          placeholder="Your Reason For Deletion Of Account"
          required
        ></textarea>
      </div>
      <button className="btn btn-primary contactButton" type="submit">
        Delete Account
      </button>
    </form>
                    </div>
                </div>
            </div>
           
        </div>
      
        <Footer/>
    </div>
  )
}

export default DeleteAccount